import { Outlet } from "react-router-dom";
import { useAuthContext } from "../contexts/AuthContext";
import { getLoginUrlWithRedirect } from "../constants/auth";

function ProtectedRoute() {
  const { isAuthenticated, isResolving } = useAuthContext();

  if (isResolving) {
    // Silent refresh / portal redirect in flight — render nothing rather than a
    // flash of unauthenticated content.
    return null;
  }

  if (!isAuthenticated) {
    window.location.href = getLoginUrlWithRedirect();
    return null;
  }

  return <Outlet />;
}

export default ProtectedRoute;
